export default __webpack_public_path__ + "static/media/screen_livechat_12.1e1ffa54.png";